import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { A11yModule } from "@angular/cdk/a11y";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatCardModule } from "@angular/material/card";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatOptionModule } from "@angular/material/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CriticalPointTemplateRoutingModule } from "./critical-point-template-routing.module";
import { CriticalPointTemplatePageComponent } from "./components/critical-point-template-page/critical-point-template-page.component";
import { CriticalPointTemplateEditDialogComponent } from "./components/critical-point-template-edit-dialog/critical-point-template-edit-dialog.component";
import { CriticalPointTemplateSelectorDialogComponent } from "./components/critical-point-template-selector-dialog/critical-point-template-selector-dialog.component";
import { CriticalPointTemplateAutocompleteComponent } from "./components/critical-point-template-autocomplete/critical-point-template-autocomplete.component";
import { HighlightTextPipe } from "./pipes/highlight-text.pipe";

@NgModule({
  declarations: [
    CriticalPointTemplatePageComponent,
    CriticalPointTemplateEditDialogComponent,
    CriticalPointTemplateSelectorDialogComponent,
    CriticalPointTemplateAutocompleteComponent,
    HighlightTextPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatCheckboxModule,
    A11yModule,
    CriticalPointTemplateRoutingModule,
  ],
  exports: [
    CriticalPointTemplateSelectorDialogComponent,
    CriticalPointTemplateAutocompleteComponent,
    MatCheckboxModule,
  ],
})
export class CriticalPointTemplateModule {}

